import PropTypes from 'prop-types';

const InfoboxCmp = ({xPosition, yPosition, zPosition, text, img}) => {
  return (
    <>
      <a-box
        src={img ? img : null}
        position={`${xPosition} ${yPosition} ${zPosition}`}
        color="#000"
        height="2"
        width="3"
      >
      </a-box>
      {text && (
        <a-text 
        value={text}
        position={`${xPosition-1.25} ${yPosition+0.75} ${zPosition+0.5}`} 
        color="#fff" 
        >
        </a-text>
      )}
    </>
  );
}

InfoboxCmp.propTypes = {
  xPosition: PropTypes.number.isRequired,
  yPosition: PropTypes.number.isRequired,
  zPosition: PropTypes.number.isRequired,
  text: PropTypes.string,
  img: PropTypes.string,
}
  
InfoboxCmp.defaultProps = {
  xPosition: 0,
  yPosition: 0,
  zPosition: 0,
}
  
export default InfoboxCmp;
